import { keys } from "./enum.js";

export const nfeKeysDefault = [
  { title: "N°", value: keys.nItem, order: 0 },
  { title: "C. Prod", value: keys.cProd, order: 1, alignRight: true },
  { title: "Descrição", value: keys.xProd, order: 2 },
  {
    title: "NCM",
    value: keys.ncm,
    order: 3,
    alignRight: true,
    editable: true,
    maxlength: 8,
  },
  {
    title: "Valor",
    value: keys.vlItem,
    order: 4,
    alignRight: true,
    filter: "currency",
  },
  {
    title: "Desc.",
    value: keys.vlDesc,
    order: 5,
    alignRight: true,
    filter: "currency",
  },
  {
    title: "Vl. Liquido",
    value: keys.vlLiquido,
    order: 6,
    alignRight: true,
    filter: "currency",
  },
  { title: "CFOP", value: keys.cfop, order: 7, alignRight: true },
  { title: "CST ICMS", value: keys.cstIcms, order: 8, alignRight: true },
  {
    title: "Vl. BcIcms",
    value: keys.vlBcIcms,
    order: 9,
    alignRight: true,
    filter: "currency",
  },
  {
    title: "Aliq. Icms",
    value: keys.aliqIcms,
    order: 10,
    alignRight: true,
    filter: "noCurrency",
  },
  {
    title: "Vl. Icms",
    value: keys.vlIcms,
    order: 11,
    alignRight: true,
    filter: "currency",
  },
  { title: "QTD", value: keys.qtd, order: 12, alignRight: true },
  { title: "Operação", value: keys.operacao, order: 13 },
];

export const nfeKeysRefAccountScreen = [
  ...nfeKeysDefault,
  {
    title: "Cod. Domínio",
    value: keys.codigoDominio,
    order: 14,
    alignRight: true,
  },
  { title: "Cod. Cta", value: keys.codCta, order: 15, alignRight: true },
  { title: "Nome Cta", value: keys.nomeCta, order: 16 },
  { title: "Operação Cta", value: keys.operacaoContabil, order: 17 },
];

export const spedKeysDefault = [
  { title: "N°", value: keys.numItem, order: 0, isString: true },
  {
    title: "Descrição",
    value: keys.descrItem,
    order: 2,
    isString: true,
    maxWidth: 210,
  },
  {
    title: "NCM",
    value: keys.codNcm,
    order: 3,
    alignRight: true,
    editable: true,
    isString: true,
    maxlength: 8,
  },
  {
    title: "Valor",
    value: keys.vlItem,
    order: 4,
    alignRight: true,
    filter: "currency",
    editable: true,
    isRequired: true,
    default: 0,
  },
  {
    title: "Desc.",
    value: keys.vlDesc,
    order: 5,
    alignRight: true,
    filter: "currency",
    editable: true,
  },
  {
    title: "CFOP",
    value: keys.cfop,
    order: 6,
    alignRight: true,
    editable: true,
    maxlength: 4,
    isRequired: true,
    default: 0,
  },
  {
    title: "CST ICMS",
    value: keys.cstIcms,
    order: 7,
    alignRight: true,
    editable: true,
    maxlength: 3,
    isString: true,
    isRequired: true,
    default: "0",
  },
  {
    title: "Vl. BcIcms",
    value: keys.vlBcIcms,
    order: 8,
    alignRight: true,
    filter: "currency",
    editable: true,
    desableIfNotMovIcms: true,
  },
  {
    title: "Aliq. Icms",
    value: keys.aliqIcms,
    order: 9,
    alignRight: true,
    filter: "noCurrency",
    editable: true,
    desableIfNotMovIcms: true,
  },
  {
    title: "Vl. Icms",
    value: keys.vlIcms,
    order: 10,
    alignRight: true,
    filter: "currency",
    editable: true,
    desableIfNotMovIcms: true,
  },
  {
    title: "QTD",
    value: keys.qtd,
    order: 11,
    alignRight: true,
    editable: true,
    isRequired: true,
    default: 0,
  },
  { title: "Operação", value: keys.operacao, order: 12, isString: true },
  { title: "ID RegC170", value: keys.idRegC170, order: 13, alignRight: true },
  {
    title: "Cod. Item",
    value: keys.codItem,
    order: 1,
    alignRight: true,
    isString: true,
  },
];

export const preSelectedKeysNfeOnRefContabil = [
  keys.nItem,
  keys.xProd,
  keys.vlItem,
  keys.vlLiquido,
  keys.operacao,
  keys.codigoDominio,
  keys.codCta,
  keys.nomeCta,
];

export const preSelectedKeysNfeOnAuditoriaCFOP = [
  keys.nItem,
  keys.xProd,
  keys.cfop,
  keys.cstIcms,
  keys.ncm,
  keys.vlItem,
  keys.vlDesc,
  keys.vlBcIcms,
  keys.aliqIcms,
  keys.vlIcms,
];

export const keysSelectedToSum = [
  { item: "Valor", value: keys.vlItem },
  { item: "Desc.", value: keys.vlDesc },
  { item: "Vl. Icms", value: keys.vlIcms },
  { item: "Vl. BcIcms", value: keys.vlBcIcms },
  { item: "Aliq. Icms", value: keys.aliqIcms },
];

export const generateNewProduct = (product, higherNumItem) => {
  return {
    aliqIcms: null,
    cfop: 0,
    codItem: product.codItem,
    cstIcms: "0",
    descrItem: product.descrItem,
    idRegC170: 0,
    numItem: `${higherNumItem + 1}`,
    aliqCofinsPercent: product.aliqCofinsPercent,
    aliqPisPercent: product.aliqPisPercent,
    cstPis: product.cstPis,
    operacao: "",
    qtd: 0,
    vlBcIcms: 0,
    vlDesc: 0,
    vlIcms: 0,
    vlItem: 0,
    unid: "UN",
    indMov: "0",
    codNcm: "00000000",
    codNat: "",
    vlBcIcmsSt: 0,
    aliqSt: null,
    vlIcmsSt: 0,
    indApur: "",
    cstIpi: "",
    codEnq: "",
    vlBcIpi: 0,
    aliqIpi: null,
    vlIpi: 0,
    vlBcPis: 0,
    quantBcPis: null,
    aliqPisValor: 0,
    vlPis: 0,
    vlBcCofins: 0,
    vlCofins: 0,
    aliqCofinsValor: 0,
    quantBcCofins: null,
    newProduct: true,
  };
};
